<template>
  <div class="password-set with-background">
    <b-container class="password-set-container">
      <b-row>
        <b-col>
          <h1>Crear contraseña</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" offset-md="3">
          <p>
            Para poder crear ofertas y realizar pujas durante la subasta en
            vivo, debe ingresar con su código de afiliado y una contraseña, la
            cual puede crear en esta página.
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" offset-md="3">
          <b-form v-on:submit.prevent="createPassword">
            <b-form-group
              id="code"
              label="Código de afiliado:"
              label-for="code"
              description="Según le fue asignado durante su afiliación."
            >
              <b-form-input id="code" type="number" required disabled :value="code"></b-form-input>
            </b-form-group>
            <b-form-group id="name" label="Nombre:" label-for="name">
              <b-form-input id="name" required disabled :value="name"></b-form-input>
            </b-form-group>
            <b-form-group
              id="password"
              label="Contraseña:"
              label-for="password"
              :description="passwordDescription"
            >
              <b-form-input id="password" type="password" required v-model="password"></b-form-input>
              <password v-model="password" @score="setPasswordScore" :strength-meter-only="true" />
            </b-form-group>
            <b-form-group
              id="password_confirm"
              label="Confirme su contraseña:"
              label-for="password_confirm"
              :description="passwordConfirmDescription"
            >
              <b-form-input
                id="password_confirm"
                type="password"
                required
                v-model="passwordConfirm"
              ></b-form-input>
            </b-form-group>
            <p class="text-right">
              <b-button variant="primary" size="lg" :disabled="!isSubmitEnabled" type="submit">Crear</b-button>
            </p>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Password from "vue-password-strength-meter";

export default {
  name: "PasswordSet",
  components: {
    Password
  },
  data() {
    return {
      password: "",
      passwordConfirm: "",
      passwordScore: 0,
      code: 0,
      name: "",
      token: ""
    };
  },
  methods: {
    setPasswordScore: function(score) {
      this.passwordScore = score;
    },
    createPassword: function() {
      this.axios
        .post(
          "/fts/users/reset-password",
          {
            password: this.password
          },
          {
            headers: { Authorization: "Bearer " + this.token }
          }
        )
        .then(resp => {
          if (resp.status !== 201) {
            this.$swal({
              title: "Error",
              text: "Ocurrió un error inesperado.  Por favor intente de nuevo",
              icon: "error"
            });
          }

          this.$swal({
            title: "Usuario creado",
            text:
              "Tu usuario ha sido habilitado.  Serás enviado al sitio principal para iniciar sesión",
            icon: "success"
          });

          this.$router.push("/");
        })
        .catch(() => {
          this.$swal({
            title: "Error",
            text: "Ocurrió un error inesperado.  Por favor intente de nuevo",
            icon: "error"
          });
        });
    }
  },
  computed: {
    passwordDescription: function() {
      if (this.passwordScore > 0 && this.passwordScore < 4) {
        return "La contraseña es muy insegura.  Considere alargarla o ingresar números, símbolos y alternar mayúsculas y minúsculas";
      }
      return "";
    },
    passwordConfirmDescription: function() {
      if (
        (this.password.length > 0 || this.passwordConfirm.length > 0) &&
        this.password !== this.passwordConfirm
      ) {
        return "La confirmación de la contraseña no coincide";
      }
      return "";
    },
    isSubmitEnabled: function() {
      return (
        this.passwordDescription === "" &&
        this.passwordConfirmDescription === "" &&
        this.password !== ""
      );
    }
  },
  created: function() {
    this.axios
      .post("/fts/users/reset", {
        password_code: this.$route.params.passwordCode
      })
      .then(resp => {
        if (resp.status !== 200) {
          this.$router.push("/");
          return;
        }

        if (!resp.data.reset) {
          this.$router.push("/");
          return;
        }

        this.code = resp.data.code;
        this.name = resp.data.name;
        this.token = resp.data.token;
      })
      .catch(() => {
        this.$router.push("/");
      });
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/partial";

.password-set {
  display: flex;
  flex-direction: column;
}

.password-set-container {
  background-color: $white;
  flex: 1 0 auto;
  padding-bottom: 2rem;
}
</style>
